import {SxProps, Theme, Box, useTheme, useMediaQuery} from "@mui/material";

import {designColors, getPaddingBySpacingSize} from "~/ui";

export interface BmCardViewSectionPaperNewProps {
  className?: string;
  sx?: SxProps<Theme>;
  children: React.ReactNode;
}

export const BmCardViewSectionPaperNew: React.FC<BmCardViewSectionPaperNewProps> = ({className, sx, children}) => {
  const theme = useTheme();
  const isLowerThanMd = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      className={className}
      sx={{
        p: getPaddingBySpacingSize(isLowerThanMd ? "md" : "lg"),
        borderRadius: "10px",
        border: `1px solid ${designColors.grey_2}`,
        backgroundColor: designColors.white,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
